import trigger from './trigger';

const getInput = (el) => (el.tagName === 'INPUT' ? el : el.querySelector('input'));

const sanitizar = (valor) => (valor || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

const ehSomenteNumerico = (limpo) => /^\d*$/.test(limpo);

const aplicarMascaraCpf = (limpo) => {
  const numerico = limpo.replace(/\D/g, '').slice(0, 11);
  if (numerico.length <= 3) return numerico;
  if (numerico.length <= 6) return `${numerico.slice(0, 3)}.${numerico.slice(3)}`;
  if (numerico.length <= 9) return `${numerico.slice(0, 3)}.${numerico.slice(3, 6)}.${numerico.slice(6)}`;
  return `${numerico.slice(0, 3)}.${numerico.slice(3, 6)}.${numerico.slice(6, 9)}-${numerico.slice(9, 11)}`;
};

const aplicarMascaraCnpj = (limpo) => {
  let parte = limpo.slice(0, 12);
  const cauda = limpo.slice(12, 14).replace(/\D/g, '');
  parte += cauda;

  if (parte.length <= 2) return parte;
  if (parte.length <= 5) return `${parte.slice(0, 2)}.${parte.slice(2)}`;
  if (parte.length <= 8) return `${parte.slice(0, 2)}.${parte.slice(2, 5)}.${parte.slice(5)}`;
  if (parte.length <= 12) return `${parte.slice(0, 2)}.${parte.slice(2, 5)}.${parte.slice(5, 8)}/${parte.slice(8)}`;
  return `${parte.slice(0, 2)}.${parte.slice(2, 5)}.${parte.slice(5, 8)}/${parte.slice(8, 12)}-${parte.slice(12, 14)}`;
};

const formatar = (valor) => {
  const limpo = sanitizar(valor);
  if (limpo.length <= 11 && ehSomenteNumerico(limpo)) {
    return aplicarMascaraCpf(limpo);
  }
  return aplicarMascaraCnpj(limpo);
};

const atualizar = (input) => {
  const novo = formatar(input.value);
  if (input.value !== novo) {
    input.value = novo;
    trigger(input, 'input');
  }
};

export const vCpfCnpj = {
  bind(el) {
    const input = getInput(el);
    input.addEventListener('input', () => atualizar(input));
    input.addEventListener('blur', () => atualizar(input));
  },
  update(el) {
    const input = getInput(el);
    atualizar(input);
  },
};

export default vCpfCnpj;
